module.exports = __webpack_public_path__ + "static/media/fetch-logo.cb6e04c7.svg";